mainApp.directive('siteInterface', function() {
    return {
        templateUrl: '/public/directives/siteInterface.html',
        scope: {
            id: '@',
            interface: '=',
            label: '@',
            collapse: '@',
            siteConnType: '<',
        },
        controller:  ['$scope', '$timeout','$state','GeneralUtilsService','StaticRangeTranslationService', function($scope, $timeout,$state,GeneralUtilsService,StaticRangeTranslationService) {
            $scope.tableInterfaces = [];

            /**
             * handler for clicking the interface label (showing the interface name )
             * this will expand and collapse the content accordingly
             */
            $scope.interfaceLabelClick = function () {
                $scope.showTable = $scope.showTable=='0'?'1':'0';
            };

            /**
             * the table displaying the interface content ( the global/native/routed/vlan range )
             * @type {{dataURL: dataURL, items: Array, fields: [*], alternativeHead: [*], addAction: addAction, parseData: parseData, onSelect: onSelect, multiSelect: boolean, deselect: boolean, noAutoSelect: boolean, type: string, selectedItems: Array, pageSize: number, actions: Array, hideCheckboxes: boolean, datamodified: number, directOnly: *, innerLoader: boolean, sortList: Array, specialActions: [*], noSearch: boolean}}
             */
            $scope.interfaceTableConfig = {
                dataURL : function(){
                    return null;
                },
                items:[],
                fields : [
                    {'label':'','path':'item','template':'<single-range ></single-range>'}
                ],
                alternativeHead: [
                    {'label': 'Range Type', 'path': 'priority', noSort: true},
                    {'label': 'IP Ranges', 'path': 'description', noSort: true},
                    {'label': 'Characteristics', 'path': 'from', noSort: true},
                    {'label': ' ', 'path': '', noSort: true},
                    {'label': 'DHCP Settings', 'path': '', noSort: true}
                ],
                addAction : function(){

                    let defaultSubnetType = $scope.interfaceTableConfig.subnetTypes[0];
                    let defaultDhcpType = $scope.interfaceTableConfig.dhcpTypes[0];
                    if ($scope.siteConnType?.value === 'VSOCKET_VGX_AWS' || $scope.siteConnType?.value === 'VSOCKET_VGX_AZURE'){
                        defaultSubnetType = $scope.interfaceTableConfig.subnetTypes.filter(sb => sb.value === 'ROUTED_ROUTE')[0];
                    }

                    let newItem = {id:GeneralUtilsService.getRandomId(), name: "",subRange:{}, subnetType: defaultSubnetType, dhcpType: defaultDhcpType};

                    // We use 2 arrays
                    // One that has the SECONDARY_NATIVE for the back end
                    // Another that does not have SECONDARY_NATIVE for the front end
                    $scope.tableInterfaces.push(newItem);
                    $scope.interface.subnets.push(newItem);
                },
                parseData: function(){
                    if($scope.interface){
                        // The secondary native range is saved as a subnet but should be treated the same as the native range
                        $scope.tableInterfaces = $scope.interface.subnets.filter(sb => sb.subnetType.value !== 'SECONDARY_NATIVE');
                        $scope.pinnedItems = [$scope.interface];
                        if ($scope.interface.subnets.some(sb => sb.subnetType.value === 'SECONDARY_NATIVE')){
                            $scope.pinnedItems.push($scope.interface.subnets.filter(sb => sb.subnetType.value === 'SECONDARY_NATIVE').pop())
                        }
                    }
                    else{
                        $scope.tableInterfaces = [];
                    }
                    return $scope.tableInterfaces;
                },
                onSelect: function(index) {

                },
                multiSelect: false,
                deselect: true,
                noAutoSelect: true,
                selectedItems:[],
                pageSize:10,
                actions: [],
                hideCheckboxes: true,
                datamodified: new Date().getTime(),
                innerLoader: true,
                sortList : [],
                specialActions : [
                    {"func":function(selectedItems) {
                        selectedItems.forEach(function(item) {

                            // We use 2 arrays
                            // One that has the SECONDARY_NATIVE for the back end
                            // Another that does not have SECONDARY_NATIVE for the front end
                            _.remove($scope.tableInterfaces, subnet => subnet.id === item.id);
                            _.remove($scope.interface.subnets, subnet => subnet.id === item.id);
                        });
                    },"icon":"delete",tooltip:"Delete"}
                ],
                noSearch:true,
                networkSettings: $scope.interface?.metadata,
                subnetTypes: $scope.interface?.metadata?.supportedSiteSubnetTypes,
                dhcpTypes: $scope.interface?.metadata?.supportedDhcpConfigurations,
                dhcpRelayGroups: $scope.interface?.metadata?.accountDhcpRelayGroups,
                initSubnetType: (subnetType) => {
                    if ($scope.interfaceTableConfig.subnetTypes && subnetType){
                        subnetType = $scope.interfaceTableConfig.subnetTypes.filter(st => st.value === subnetType.value)[0];
                        return subnetType;
                    }
                },
                setDhcpTypeIfNeeded: (item) => {
                  if (item.subnetType.value === 'VLAN'){
                      item.dhcpType = $scope.interfaceTableConfig.dhcpTypes.filter(st => st.value === 'ACCOUNT_DEFAULT')[0];
                  } else {
                      item.dhcpType = $scope.interfaceTableConfig.dhcpTypes[0];
                  }
                },
                initDhcpRelay: (item) => {
                    if ($scope.interfaceTableConfig.dhcpRelayGroups && item){
                        return (item.dhcpRelayGroup) ? item.dhcpRelayGroup : $scope.interfaceTableConfig.dhcpRelayGroups[0];
                    }
                },
                resetDhcpOnTypeChange: (item, dhcpRange) => {
                    if (item.dhcpType.value === 'ACCOUNT_DEFAULT' || item.dhcpType.value === 'DHCP_RELAY'){
                        delete item[dhcpRange];
                    } else if (item[dhcpRange]?.subnet){
                        item[dhcpRange].subnet = null;
                    }
                },
            };


            /**
             * initiate the directive
             */
            function init() {
                StaticRangeTranslationService.getStaticRangeTranslationEnabled($state.params.accountId,function (data) {
                    $scope.interfaceTableConfig.staticRangeTranslationEnabled = data;
                });
                $scope.interfaceTableConfig.datamodified = new Date().getTime();
                $scope.showTable = $scope.collapse == '0'?'0':'1';
            }


            // running the init function only after screen was loaded
            $timeout(function() {
                init();
            }, 0);
        }]
    }
});
